import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";
const MembershipTestimonials = () => {
  const testimonials = [{
    name: "Sarah M.",
    tier: "Signature Member",
    quote: "The credits system makes it so easy to try different treatments. I've discovered services I never would have considered before!",
    rating: 5,
    treatments: "Botox, Facials, IV Therapy"
  }, {
    name: "Jessica L.",
    tier: "Essential Member",
    quote: "Being a member has saved me hundreds of dollars. The priority booking is a game-changer for my busy schedule.",
    rating: 5,
    treatments: "Monthly Facials, Dermaplaning"
  }, {
    name: "Amanda R.",
    tier: "Transformational Member",
    quote: "The unlimited benefits and exclusive treatments have completely transformed my self-care routine. Worth every penny!",
    rating: 5,
    treatments: "Full Treatment Access"
  }];
  return <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-juv-deep-chestnut mb-4 font-serif">
            What Our Members Say
          </h2>
          <p className="text-lg text-juv-deep-chestnut/70 max-w-2xl mx-auto">
            Real experiences from JUV members who've transformed their wellness journey
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => <Card key={index} className="border-juv-rose-clay/20 shadow-luxury hover:shadow-editorial transition-all duration-300">
              <CardContent className="p-8 bg-slate-50">
                <div className="flex items-center mb-4">
                  <Quote className="w-8 h-8 text-juv-terracotta mr-3" />
                  <div className="flex">
                    {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-juv-terracotta text-juv-terracotta" />)}
                  </div>
                </div>
                
                <blockquote className="text-juv-deep-chestnut mb-6 leading-relaxed italic">
                  "{testimonial.quote}"
                </blockquote>
                
                <div className="border-t border-juv-rose-clay/20 pt-4">
                  <p className="font-semibold text-juv-deep-chestnut">{testimonial.name}</p>
                  <p className="text-sm text-juv-terracotta">{testimonial.tier}</p>
                  <p className="text-xs text-juv-deep-chestnut/60 mt-1">
                    Favorite Treatments: {testimonial.treatments}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
};
export default MembershipTestimonials;